import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import {
  AuthGuardValidation,
  BlockPageAuthGuard,
  CanAuthenticationGuard,
} from 'src/app/utils/authguard';
import { MaintenanceDialogComponent } from './maintenance-dialog.component';
import { MatDialogModule } from '@angular/material/dialog';
import { BrowserModule } from '@angular/platform-browser';
import { MaterialModule } from 'src/app/material/material.module';
import { TranslateModule } from '@ngx-translate/core';
import { MatTooltipModule } from '@angular/material/tooltip';

const routes = [
  {
    path: 'maintenance-dialog',
    component: MaintenanceDialogComponent,
    canActivate: [AuthGuardValidation, BlockPageAuthGuard],
  },
];

@NgModule({
  declarations: [MaintenanceDialogComponent],
  exports: [MaintenanceDialogComponent],
  imports: [
    RouterModule.forChild(routes),
    MatDialogModule,
    MaterialModule,
    TranslateModule,
    BrowserModule,
    MatTooltipModule,
  ],
  providers: [CanAuthenticationGuard],
})
export class MaintenanceDialogModule {}
